import { ECommercialOwnershipVerificationFormViewFields } from '../../enums';

type TLabelsByFieldName = { [K in ECommercialOwnershipVerificationFormViewFields]: string };

export const LABELS_BY_FIELD_NAME: TLabelsByFieldName = {
  [ECommercialOwnershipVerificationFormViewFields.CadastralNumber]: 'Кадастровый номер',
  [ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]: 'Кто собственник?',
  [ECommercialOwnershipVerificationFormViewFields.Inn]: 'ИНН',
  [ECommercialOwnershipVerificationFormViewFields.LastName]: 'Фамилия',
  [ECommercialOwnershipVerificationFormViewFields.FirstName]: 'Имя',
  [ECommercialOwnershipVerificationFormViewFields.SecondName]: 'Отчество',
  [ECommercialOwnershipVerificationFormViewFields.CompanyName]: 'Компания',
};
